'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var TextLink = require('@narvar/nth-bit-text-link');
var nthBitHeader = require('@narvar/nth-bit-header');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var useOrderTracking = require('@narvar/nth-hook-order-tracking');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);
var useOrderTracking__default = /*#__PURE__*/_interopDefaultLegacy(useOrderTracking);

var DescriptionFormatEnum = /*#__PURE__*/function (DescriptionFormatEnum) {
  DescriptionFormatEnum["HTML"] = "HTML";
  return DescriptionFormatEnum;
}(DescriptionFormatEnum || {});
const toKebab = key => key.replace(/([a-z\d])([A-Z])/g, '$1-$2').toLowerCase();
const styleObjectToString = s => Object.entries(s).reduce((accum, _ref) => {
  let [key, value] = _ref;
  return `${toKebab(key)}:${value};${accum}`;
}, '');
const ShippingHistoryEventList = styled__default["default"].ol.withConfig({
  componentId: "sc-1ni9lpn-0"
})(["margin:0;list-style:none;padding:0;"]);
const ShippingHistoryEventItem = styled__default["default"].li.withConfig({
  componentId: "sc-1ni9lpn-1"
})(_ref2 => {
  let {
    style
  } = _ref2;
  return {
    margin: 0,
    ...style
  };
});
const Description = styled__default["default"].p.withConfig({
  componentId: "sc-1ni9lpn-2"
})(["margin:0 0 1rem 0;line-height:1.25rem;", " ", " ", ""], _ref3 => {
  let {
    s
  } = _ref3;
  return s ? `${styleObjectToString(s)};` : '';
}, _ref4 => {
  let {
    linkDefault
  } = _ref4;
  return linkDefault ? `a { ${styleObjectToString(linkDefault)} }` : '';
}, _ref5 => {
  let {
    linkHover
  } = _ref5;
  return linkHover ? `a:hover { ${styleObjectToString(linkHover)} }` : '';
});
const TrackingEvents = _ref6 => {
  let {
    featureName
  } = _ref6;
  const {
    bodytextDefaultNone,
    smalltextDefaultNone,
    smalltextEmphasisNone,
    linksNoneDefault,
    linksNoneHover
  } = nthHookTheme.useTheme();
  const {
    shippingActivityGenericHeaderText,
    shippingActivityLatestUpdateText,
    shippingActivityShowFullHistoryButtonText,
    shippingActivityHideFullHistoryButtonText,
    trackingStatusNoEddSubtext
  } = nthHookTranslations.useTranslations();
  const {
    getCurrentShipment
  } = useOrderTracking__default["default"]();
  const currentShipment = getCurrentShipment();
  const {
    eddPanel
  } = nthHookSettings.useSettings();
  const {
    expandEventHistoryByDefault = false
  } = eddPanel || {};
  const [collapsed, setCollapsed] = React.useState(!expandEventHistoryByDefault);
  React.useEffect(() => {
    setCollapsed(!expandEventHistoryByDefault);
  }, [expandEventHistoryByDefault]);
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  if (!currentShipment) return null;
  const {
    history: fullHistory,
    trackingNumber,
    carrier
  } = currentShipment;
  if (!fullHistory || fullHistory.length === 0) return /*#__PURE__*/React__default["default"].createElement("p", {
    style: {
      lineHeight: '1.25rem',
      marginTop: 0,
      ...bodytextDefaultNone
    }
  }, trackingStatusNoEddSubtext);
  const history = collapsed ? [fullHistory[0]] : fullHistory;
  const collapsedToggleVisible = fullHistory.length > 1;
  const historyGroupedByDate = history.reduce((acc, event) => {
    const {
      dateFormatted: [date]
    } = event;
    const eventList = acc.get(date);
    if (eventList) {
      eventList.push(event);
    } else {
      acc.set(date, [event]);
    }
    return acc;
  }, new Map());
  return /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      margin: '1rem 0'
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    "data-test": "shippingHistoryCollapseButtonContainer",
    style: {
      marginBottom: collapsed ? '1rem' : '1.25rem'
    }
  }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SmallHeader, {
    as: "h3",
    featureName: featureName,
    containerCustomStyle: {
      display: 'inline-block',
      marginRight: '0.5rem'
    }
  }, collapsed ? shippingActivityLatestUpdateText : shippingActivityGenericHeaderText), collapsedToggleVisible && /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    linkStyle: {
      sDefault: linksNoneDefault,
      sHover: linksNoneHover
    },
    onClick: () => {
      const clickDescription = collapsed ? nthHookContextAnalytics.NarvarClickSubTypes.SHOW_SHIPPING_HISTORY : nthHookContextAnalytics.NarvarClickSubTypes.HIDE_SHIPPING_HISTORY;
      logEvent({
        clickCategory: clickDescription,
        clickSubType: clickDescription,
        clickType: nthHookContextAnalytics.NarvarClickTypes.INTERACTION,
        eventCarrierMoniker: carrier,
        eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BUNDLE_SHIPPING_ACTIVITY,
        eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_BUNDLE_SHIPPING_ACTIVITY,
        eventTrackingNumber: trackingNumber,
        eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
        feature: featureName,
        pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BUNDLE_SHIPPING_ACTIVITY
      });
      setCollapsed(!collapsed);
    }
  }, collapsed ? shippingActivityShowFullHistoryButtonText : shippingActivityHideFullHistoryButtonText)), /*#__PURE__*/React__default["default"].createElement(ShippingHistoryEventList, {
    "data-test": "shippingHistoryEventsContainer"
  }, [...historyGroupedByDate.entries()].map((_ref7, idx) => {
    let [date, eventList] = _ref7;
    return /*#__PURE__*/React__default["default"].createElement(ShippingHistoryEventItem, {
      key: date,
      style: {
        marginTop: idx && '1.5rem'
      }
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      style: {
        display: collapsed ? 'inline-block' : 'block',
        marginBottom: collapsed ? '0rem' : '0.5rem',
        marginRight: '0.25rem',
        ...smalltextEmphasisNone
      }
    }, /*#__PURE__*/React__default["default"].createElement("time", null, date)), /*#__PURE__*/React__default["default"].createElement(ShippingHistoryEventList, null, eventList.map(_ref8 => {
      let {
        description,
        formattedDescription,
        city,
        state,
        dateFormatted: [, time]
      } = _ref8;
      const timeAndLocation = /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("time", null, time), time && (city || state) && /*#__PURE__*/React__default["default"].createElement("span", {
        "aria-hidden": "true"
      }, "\xA0|\xA0"), /*#__PURE__*/React__default["default"].createElement("span", null, city, city && state && ', ', state));
      const descriptionElement = formattedDescription && formattedDescription.format === DescriptionFormatEnum.HTML && formattedDescription.value ? /*#__PURE__*/React__default["default"].createElement(Description, {
        s: bodytextDefaultNone,
        linkDefault: linksNoneDefault,
        linkHover: linksNoneHover,
        dangerouslySetInnerHTML: {
          __html: formattedDescription.value
        }
      }) : /*#__PURE__*/React__default["default"].createElement(Description, {
        s: bodytextDefaultNone
      }, description);
      return /*#__PURE__*/React__default["default"].createElement(ShippingHistoryEventItem, {
        key: `${date}${time}${city ?? ''}${state ?? ''}${description ?? ''}`
      }, /*#__PURE__*/React__default["default"].createElement("span", {
        style: {
          display: collapsed ? 'inline-block' : 'block',
          ...smalltextDefaultNone
        }
      }, timeAndLocation), descriptionElement);
    })));
  })));
};
var TrackingEvents$1 = nthHookSettings.withSettingsProvider(nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(TrackingEvents, {
  themeTokens: ['bodytextDefaultNone', 'smalltextDefaultNone', 'smalltextEmphasisNone', 'linksNoneDefault', 'linksNoneHover']
}), {
  translationKeys: ['shippingActivityGenericHeaderText', 'shippingActivityLatestUpdateText', 'shippingActivityShowFullHistoryButtonText', 'shippingActivityHideFullHistoryButtonText', 'trackingStatusNoEddSubtext']
}), {
  settingsRequested: `
      eddPanel {
        expandEventHistoryByDefault
      }
    `
});

exports["default"] = TrackingEvents$1;
